import { render } from "./WhitelabelConfigForm.vue?vue&type=template&id=02010b1e"
import script from "./WhitelabelConfigForm.vue?vue&type=script&lang=js"
export * from "./WhitelabelConfigForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__